import { createContext, useEffect, useMemo, useState } from "react";
import { useGetPatientTasksQuery } from "src/api/services/tasksApi";
import TaskModal from "src/shared/components/TaskModal";

export const PopupContext = createContext<unknown | null>(null);

interface Props {
  children: React.ReactNode;
}

const PopupProvider = ({ children }: Props) => {
  const [displayPaymentFailed, setDisplayPaymentFailed] =
    useState<boolean>(false);
  const [displayRateOrder, setDisplayRateOrder] = useState<boolean>(false);
  const [displayRateExperience, setDisplayRateExperience] =
    useState<boolean>(false);
  const { data = [] } = useGetPatientTasksQuery();

  const unpaidOrderTask = useMemo(() => {
    const task = data.find((t) => t.task_type === "UNPAID_ORDER");
    return task;
  }, [data]);

  const rateOrderTask = useMemo(() => {
    const task = data.find((t) => t.task_type === "RATE_ORDER");
    return task;
  }, [data]);

  const rateExperienceTask = useMemo(() => {
    const task = data.find((t) => t.task_type === "RATE_EXPERIENCE");
    return task;
  }, [data]);

  useEffect(() => {
    if (unpaidOrderTask) {
      setDisplayPaymentFailed(true);
    }

    if (rateOrderTask) {
      setDisplayRateOrder(true);
    }

    if (rateExperienceTask) {
      setDisplayRateExperience(true);
    }
  }, [rateExperienceTask, rateOrderTask, unpaidOrderTask]);

  return (
    <PopupContext.Provider value={null}>
      {unpaidOrderTask != null ? (
        <TaskModal
          open={displayPaymentFailed}
          onClose={setDisplayPaymentFailed}
          task={unpaidOrderTask}
        />
      ) : null}
      {rateOrderTask != null ? (
        <TaskModal
          open={displayRateOrder}
          onClose={setDisplayRateOrder}
          task={rateOrderTask}
        />
      ) : null}
      {rateExperienceTask != null ? (
        <TaskModal
          open={displayRateExperience}
          onClose={setDisplayRateExperience}
          task={rateExperienceTask}
        />
      ) : null}
      {children}
    </PopupContext.Provider>
  );
};

export default PopupProvider;
